module.exports = __webpack_public_path__ + "static/media/icon7.png";